import app from 'flarum/forum/app';
import UserPage from 'flarum/forum/components/UserPage';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Placeholder from 'flarum/common/components/Placeholder';
import Button from 'flarum/common/components/Button';
export default class AuthorizedPage extends UserPage {
  records = [];
  loading = true;
  nomore = false;
  page = 0;
  oninit(vnode) {
    super.oninit(vnode);
    this.loadUser(m.route.param('username'));
    this.loadRecords();
  }
  loadRecords() {
    app.store.find('oauth-records', {
      page: {
        offset: this.page * 10
      }
    }).then(records => {
      this.records = this.records.concat(records);
      this.loading = false;
      if (records.length < 10) {
        this.nomore = true;
      }
      m.redraw();
    });
  }
  loadMore() {
    this.loadRecords(this.page += 1);
  }
  content() {
    if (this.records.length === 0) {
      return m(Placeholder, {
        text: app.translator.trans('foskym-oauth-center.forum.authorized.no_records')
      });
    }
    let allow_delete = app.forum.attribute('foskym-oauth-center.allow_delete_records');
    console.log(allow_delete);
    return m("div", {
      className: "AuthorizedPage"
    }, allow_delete && m(Button, {
      className: 'Button Button--danger',
      onclick: () => {
        window.confirm(app.translator.trans('foskym-oauth-center.forum.authorized.delete_all_confirm')) && app.request({
          url: app.forum.attribute('apiUrl') + '/oauth-records/user',
          method: 'DELETE'
        }).then(() => {
          this.records = [];
          this.nomore = false;
          this.loadMore();
        });
      }
    }, app.translator.trans('foskym-oauth-center.forum.authorized.delete_all_button')), m("ul", {
      className: "AuthorizedRecords"
    }, this.records.map(record => m("li", {
      className: "AuthorizedRecord"
    }, m("div", {
      className: "AuthorizedRecord-content"
    }, m("div", {
      className: "AuthorizedRecord-left"
    }, m("img", {
      className: "AuthorizedRecord-icon",
      src: record.attribute('client').client_icon,
      alt: "client_icon"
    }), m("div", {
      className: "AuthorizedRecord-info"
    }, m("h3", null, m("a", {
      href: record.attribute('client').client_home,
      target: "_blank"
    }, record.attribute('client').client_name)), m("p", null, record.attribute('client').client_desc))), m("div", {
      className: "AuthorizedRecord-right"
    }, m("time", null, record.authorized_at().toLocaleString()), allow_delete && m(Button, {
      className: 'Button Button--danger Button--small',
      onclick: () => {
        record.delete().then(() => {
          this.records = this.records.filter(r => r !== record);
          m.redraw();
        });
      }
    }, app.translator.trans('foskym-oauth-center.forum.authorized.delete_button')))), m("hr", null)))), this.loading && m(LoadingIndicator, {
      display: "block"
    }), !this.loading && !this.nomore && m("div", {
      style: "text-align:center;padding:20px"
    }, m(Button, {
      className: 'Button Button--primary',
      disabled: this.loading,
      loading: this.loading,
      onclick: () => this.loadMore()
    }, app.translator.trans('foskym-oauth-center.forum.authorized.load_more'))), this.nomore && m(Placeholder, {
      text: app.translator.trans('foskym-oauth-center.forum.authorized.no_more_records')
    }));
  }
}
flarum.reg.add('foskym-oauth-center', 'forum/components/user/AuthorizedPage', AuthorizedPage);